import { StatusIndicator } from '@cloudscape-design/components';
import type { RuleStatus } from '@amzn/helianthus-arbiter-client';

interface RuleStatusBadgeProps {
  status: RuleStatus;
}

export function RuleStatusBadge({ status }: RuleStatusBadgeProps) {
  const statusMap: Record<RuleStatus, { type: 'success' | 'info' | 'error' | 'warning' | 'stopped' | 'pending' | 'in-progress' | 'loading'; label: string }> = {
    active: { type: 'success', label: 'Active' },
    draft: { type: 'info', label: 'Draft' },
    dry_run: { type: 'pending', label: 'Dry Run' },
    provisioning: { type: 'in-progress', label: 'Provisioning' },
    inactive: { type: 'stopped', label: 'Inactive' },
    error: { type: 'error', label: 'Error' },
    deprecated: { type: 'warning', label: 'Deprecated' },
    deleted: { type: 'stopped', label: 'Deleted' },
  };

  const { type, label } = statusMap[status];
  return <StatusIndicator type={type}>{label}</StatusIndicator>;
}
